import { singular } from 'pluralize';
import { CustomUnitKind, CustomUnitOptions } from '../schema';
import { formatDecimal } from './decimal';
import { FormatValueOptions, UnitConfig, UnitGroupConfig } from './types';

export const CUSTOM_GROUP_CONFIG: UnitGroupConfig = {
  label: 'Custom',
  decimal_places: true,
  abbreviate: true,
};

export const CUSTOM_UNIT_CONFIG: Readonly<Record<CustomUnitKind, UnitConfig>> = {
  Custom: {
    group: 'Custom',
    // Note: This will be overwritten by the user's input.
    label: 'Custom',
    // Custom unit only appears after the user starts to type.
    disableSelectorOption: true,
  },
};

export const formatCustom = (
  value: number,
  {
    value: customUnit,
    abbreviate,
    decimal_places,
    trimZeros = true,
    scientificForTinyValues = false,
  }: CustomUnitOptions & Pick<FormatValueOptions, 'trimZeros' | 'scientificForTinyValues'>
) => {
  const formatWithoutUnit = formatDecimal(value, {
    kind: 'Decimal',
    abbreviate,
    decimal_places,
    trimZeros,
    scientificForTinyValues,
  });

  if (value === 1) {
    return `${formatWithoutUnit} ${singular(customUnit)}`;
  }

  return `${formatWithoutUnit} ${customUnit}`;
};
